<template>
  <div class="notices-container">Notices</div>
</template>
<script>
export default {
  name: "NoticesComponent",
};
</script>